import React, { FC } from 'react';
import { Container } from 'react-bootstrap';

import cx from 'classnames';

import s from 'components/FooterMainFragment/FooterMainFragment.module.scss';
import MenuStructure from 'components/MenuStructure/MenuStructure';
import { IMenu } from 'models/menu';

interface IProps {
  menu: IMenu[];
}
const FooterMainFragment: FC<IProps> = ({ menu }) => {
  return (
    <>
      <div className={cx('bg-light-grey py-3', s['bg-light-grey'])}>
        <Container>
          <MenuStructure
            className="d-flex justify-content-center align-items-start align-items-sm-center flex-column flex-sm-row list-style-type-none p-0 w-100 flex-wrap"
            menu={menu}
            activeMenuClass="text-secondary"
          />
        </Container>
      </div>
      <div className="bg-white py-3">
        <Container className="d-flex flex-column align-items-center justify-content-between">
          <div className="d-flex">
            <p className="px-2">Surf Life Saving Australia Limited 2026 </p>
            <span className="px-2">ACN 003 147 180</span>
            <span className="px-2">ABN 67 449 738 159</span>
          </div>
        </Container>
      </div>
    </>
  );
};

export default FooterMainFragment;
